module.exports = __webpack_public_path__ + "img/acc7049.png";